import React, { useEffect } from 'react';
import { RestaurantMetaInfoSummary } from '../restaurant-meta-info-summary/restaurant-meta-info-summary.tsx';
import { ButtonBubbleTextIcon } from '../../../../../patterns/00-atoms/button/button.tsx';
import {
  RestaurantDetails_getRestaurantDetails_owner_claims,
  RestaurantDetails_getRestaurantDetails_operatingStatus
} from '../../../../../types/graphql-types-generated.ts';

import { Paths } from '../../../../../utils/paths.ts';
import { restaurantImageOrDefault } from '../../../../../utils/restaurant-image-or-default.ts';
import { prgLink } from '../../../../../utils/prg-resolver.ts';
import { UBTracking } from '../../../../../components/tracking/ubtracking.ts';

export type SiblingRestaurantProps = {
  sibling: RestaurantDetails_getRestaurantDetails_owner_claims & {
    averageReviewScore: number;
    reviewsCount: number;
    cuisineTranslations: { name: string; urlKey: string }[] | null;
    linkedCity: { fullnameLower: string };
    operatingStatus: RestaurantDetails_getRestaurantDetails_operatingStatus | null;
  };
};

export const SiblingRestaurant: React.FunctionComponent<SiblingRestaurantProps> = props => {
  const siblingRestaurantRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (siblingRestaurantRef.current) {
      UBTracking.onTrackTargetView(
        siblingRestaurantRef.current,
        'restaurant_info_modal',
        'sibling_restaurant',
        {
          restaurant: props.sibling
        }
      );
    }
  }, [siblingRestaurantRef]);

  return (
    <div
      ref={siblingRestaurantRef}
      onClick={() => {
        UBTracking.trackEvent.click('restaurant_info_modal', 'sibling_restaurant', {
          restaurant: props.sibling
        });
        prgLink(Paths.rdp(props.sibling));
      }}
      className="shrink-0 basis-xs cursor-pointer snap-start pl-4"
    >
      <div className="relative">
        <img
          className="h-32 w-full rounded-3xl object-cover"
          src={restaurantImageOrDefault(props.sibling.profileImageUrl)}
          alt={`Profilbild von ${props.sibling.name}`}
          loading="lazy"
        />
        {false && (
          <div className="absolute top-0 right-0 mt-2 mr-2">
            <ButtonBubbleTextIcon onClick={console.log} iconName="like" />
          </div>
        )}
      </div>
      <div className="mt-2">
        <span className="text-xl/6 font-extrabold">{props.sibling.name}</span>
        <RestaurantMetaInfoSummary restaurantDetails={props.sibling} cuisineLinking={false} />
      </div>
    </div>
  );
};
